import { render, staticRenderFns } from "./SentMessageDetail.vue?vue&type=template&id=8af574aa&scoped=true"
import script from "./SentMessageDetail.vue?vue&type=script&lang=ts"
export * from "./SentMessageDetail.vue?vue&type=script&lang=ts"
import style0 from "./SentMessageDetail.vue?vue&type=style&index=0&id=8af574aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af574aa",
  null
  
)

export default component.exports